import{css}from"@emotion/react";import styled from"@emotion/styled";const wrappedText=props=>props.wrapText?css`
        white-space: initial;
      `:css`
        white-space: nowrap;
      `;export const titleDescriptionStyles=props=>css`
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;

  color: ${props.theme.colors.neutral600};
`;const TitleDescription=styled.div`
  ${titleDescriptionStyles}
  ${wrappedText}
`;export default TitleDescription;